/**
 * True when a planet has been converted into its alliance's Team planet.
 * `!!` (not `!== undefined`): a field cleared via `set(..., null)` rather
 * than `FieldValue.delete()` serializes as `null`, not a missing key, and
 * `normalizePlanet`'s bare `...data` spread passes that straight through —
 * `!!` treats both a missing key AND a mis-serialized `null`/`""` as "not a
 * Team planet", so nothing on that spectrum is misread as an unlock.
 */
export function isTeamPlanet(planet) {
    return !!planet.allianceId;
}
//# sourceMappingURL=planet.types.js.map